export default {
  maxFetchSize: 5000,
  normalFetchSize: 10,
  processedQueueName: 'finishing_task',
};
